import { useEffect, useState } from "react";
import { EstadoRequisicao } from "store/types";


/**
 * Serve para dar foco somente quando a página é acessada diretamente
 */
export function useHashFocus(regex: RegExp, estado: EstadoRequisicao) {
  const [necessarioAplicar, setNecessarioAplicar] = useState(true);
  const requisicaoBemSuscedidada = estado === EstadoRequisicao.BEM_SUCEDIDO

  useEffect(() => {
    if (!necessarioAplicar || !requisicaoBemSuscedidada) {
      return;
    }

    const hash = window.location.hash;
    const grupos = hash.match(regex);

    // Obs: Se o elemento não for encontrado, não será dado o foco
    //      Ex: Comentários são carregados em uma lista infinita
    //          Se o comentário estiver na segunda página, não será feito mais scrool
    //          Ou seja, o scrool será dado somente para elementos da primeira página
    if (grupos !== null) {
      // Forçar atualização
      window.location.hash = `${hash}-`
      window.location.hash = hash;
    }

    return setNecessarioAplicar(false);
  }, [requisicaoBemSuscedidada, regex, necessarioAplicar, setNecessarioAplicar]);
}